import { View, Text } from 'react-native';
import { ChatPromptField } from '~/chat/components/chat-prompt-field/ChatPromptField';
import { ChatWindow } from '~/chat/components/chat-window/ChatWindow';
import { useChatWithPowerSync } from '../../hooks/useChatWithPowerSync';
import { useState } from 'react';
import { useAiCredits } from '~/purchases/hooks/useAiCredits';
import { usePaywall } from '~/purchases/hooks/usePaywall';

export interface ChatProps {}

export const Chat = () => {
  const [input, setInput] = useState('');

  const { messages, sendMessage, loading, thinking, error, clearMessages } =
    useChatWithPowerSync();
  const { credits } = useAiCredits();
  const { openPaywall } = usePaywall();

  const onSubmit = () => {
    if (!input.trim() || loading || thinking) {
      return;
    }
    // A drained FYT wallet blocks sending — open the paywall instead of posting
    // the message. `credits === null` means still loading/unauthed, so we let the
    // backend remain the authority rather than block optimistically.
    if (credits && credits.balance <= 0) {
      openPaywall();
      return;
    }
    sendMessage(input);
    setInput('');
  };

  // `bg-background` paints over the navigator's default theme card (an opaque
  // grey) that sits behind this screen inside the chat `_layout` Stack.
  return (
    <View className="flex-1 bg-background">
      {error && (
        <View className="mx-4 mb-2 p-3 bg-red-100 rounded border-l-4 border-red-500">
          <Text className="text-red-600 text-sm font-medium">
            Error: {error.message}
          </Text>
          <Text
            className="text-red-500 text-xs mt-1 underline"
            onPress={() => clearMessages()}
          >
            Clear conversation
          </Text>
        </View>
      )}

      <ChatWindow messages={messages} thinking={thinking} />

      <ChatPromptField
        value={input}
        onChangeText={setInput}
        onSubmit={onSubmit}
        disabled={loading || thinking}
      />
    </View>
  );
};
